<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content
			v-if="!page.introblock"
			:title="page.title || page.header"
			:content="page.content"
			:intro-image="{
				image: page.introductionImage,
				imageWebp: page.introductionImageWebp,
			}"
		>
			<template #extra-content>
				<div class="align-left" style="padding: 40px 0">
					<recursive-sitemap :items="sitemap" />
				</div>
			</template>
		</main-content>

		<intro-block v-if="page.introblock" :item="page.introblock" />

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions v-if="page.faqs && page.faqs.length" :items="page.faqs" />
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: sitemap } = await useWebsiteFetch('sitemap', {
	query: { language: locale.value },
	key: `${locale.value}/sitemap`,
});
</script>
